import { INTEGRATION_WORKFLOW_SLUGS } from "./integrationWorkflowKeys";

/** The setup list each app shows itself. */
export const MINIAPP_WORKFLOW_SLUGS = [
  "site-domain-setup",
  "site-tracking-setup",
  "site-seo-setup",
  "product-setup",
  "brand-setup",
  "asset-setup",
  "content-setup",
  "canvas-setup",
  "research-setup",
  "file-setup",
  "order-setup",
  "report-setup",
  "plan-setup",
  "task-setup",
  "skill-setup",
  "integration-setup",
] as const;

/**
 * Every workflow's permanent name, in the order `WORKFLOWS` lists them (and `workflow-fixtures` is generated in). A version of a base workflow that adds an integration is named
 * `<integration>-<base slug>`; the base keeps the plain name. A SaaS workflow is named `saas-…` and a
 * services one `services-…`.
 */
export const WORKFLOW_SLUGS = [
  "build-landing-page",
  "shopify-build-landing-page",
  "build-product-page",
  "shopify-build-product-page",
  "build-listicle",
  "shopify-build-listicle",
  "build-advertorial",
  "shopify-build-advertorial",
  "build-bundle",
  "shopify-build-bundle",
  "copy-page",
  "shopify-copy-page",
  "copy-competitor-page",
  "shopify-copy-competitor-page",
  "import-figma",
  "shopify-import-figma",
  "start-shopify-template",
  "build-shopify-quiz",
  "audit-shopify-page",
  "shopify-build-persona-page",
  "shopify-build-ab-variant",
  "shopify-suggest-pages",
  "shopify-build-ad-page",
  "saas-build-landing-page",
  "saas-copy-page",
  "saas-copy-competitor-page",
  "saas-import-figma",
  "saas-build-site",
  "saas-build-feature-page",
  "saas-build-pricing-page",
  "services-build-landing-page",
  "services-build-booking-page",
  "services-copy-page",
  "services-copy-competitor-page",
  "services-build-site",
  "services-build-services-page",
  "services-compare-competitor-offers",
  "services-find-creative-angles",
  "research-competitor-ads",
  "research-competitor-pages",
  "compare-competitor-offers",
  "find-creative-angles",
  "build-swipe-file",
  "write-creative-brief",
  ...MINIAPP_WORKFLOW_SLUGS,
  "connect-store",
  "connect-slack-or-assistant",
  "use-replo-from-slack",
  "use-replo-from-claude",
  "use-replo-from-chatgpt",
  ...INTEGRATION_WORKFLOW_SLUGS,
  "build-sales-funnel",
  "build-storefront",
  "find-product-to-sell",
  "import-shopify-products",
  "publish-page",
  "connect-domain",
] as const;
